import { distributedOverload, drainEfficiency, horizontalSeismicLoad, minFsSeismicConditions, minFsStaticConditions, verticalSeismicLoad } from "../conversion/load";
import { EUnitOfMeasure } from "../shared/enum";

export default {
    [distributedOverload]: {
        min: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 0,
                [EUnitOfMeasure.Imperial]: 0,
            },
        },
        max: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: undefined,
                [EUnitOfMeasure.Imperial]: undefined,
            },
        },
    },
    [horizontalSeismicLoad]: {
        min: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 0,
                [EUnitOfMeasure.Imperial]: 0,
            },
        },
        max: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 1,
                [EUnitOfMeasure.Imperial]: 1,
            },
        },
    },
    [verticalSeismicLoad]: {
        min: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 0,
                [EUnitOfMeasure.Imperial]: 0,
            },
        },
        max: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 1,
                [EUnitOfMeasure.Imperial]: 1,
            },
        },
    },
    [minFsStaticConditions]: {
        min: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 1,
                [EUnitOfMeasure.Imperial]: 3.2,
            },
        },
        max: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: undefined,
                [EUnitOfMeasure.Imperial]: undefined,
            },
        },
    },
    [minFsSeismicConditions]: {
        min: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 1,
                [EUnitOfMeasure.Imperial]: 3.2,
            },
        },
        max: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: undefined,
                [EUnitOfMeasure.Imperial]: undefined,
            },
        },
    },
    [drainEfficiency]: {
        min: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 0,
                [EUnitOfMeasure.Imperial]: 0,
            },
        },
        max: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 1,
                [EUnitOfMeasure.Imperial]: 1,
            },
        },
    },
}